<script lang="ts">
    import { getContext, onMount } from 'svelte'
    import type { Readable } from 'svelte/store'

    import type { GenOrder } from '../../order'
    import { toASCII, toUnicode } from 'punycode-esm'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'

    const orderId = getContext('orderId') as Readable<string>
    const Order = getContext('Order') as GenOrder

    let inputElement: HTMLInputElement | undefined = $state()
    let value: string = $state('')
    let authCode: string = $state('')

    let domainAscii = $derived(value ? toASCII(value) : '')
    let domainUnicode = $derived(value ? toUnicode(value).toLocaleLowerCase() : '')
    // let domainTld: string = null

    onMount(() => {
        if (inputElement) inputElement.focus()
    })

    let adding: boolean = $state(false)
    async function submit() {
        adding = true

        try {
            const r = await simpleFetch('PUT', `/json/ecom/1/order/${$orderId}/transfer-item`, { name: domainAscii, auth_code: authCode })
            value = ''
            authCode = ''
            Order.loadGenericResponse(r.data)
        } catch (e: any) {
            console.error('Failed to add transfer:', e)
            let msg = `Le transfer « ${domainAscii} » n’a pas pu être ajouté`
            notify({
                type: 'danger',
                title: 'Commande',
                text: msg + (e && e.data && e.data.error ? ` : ${e.data.error}` : '.'),
            })
        }
        adding = false
    }
</script>

<div id="order-transfer">
    <form
        class="d-grid gap-2"
        onsubmit={(e) => {
            e.preventDefault()
            submit()
        }}
    >
        <div class="row">
            <label for="trx-domain-name" class="col-sm-2 col-form-label">{$_('Domain')}</label>
            <div class="col-sm-10">
                <input id="trx-domain-name" class="form-control" bind:value bind:this={inputElement} disabled={adding} class:is-invalid={!domainAscii || !domainAscii.match(/\./)} />
            </div>
        </div>
        <div class="row">
            <label for="trx-auth-code" class="col-sm-2 col-form-label">{$_('Auth code')}</label>
            <div class="col-sm-10">
                <input type="text" id="trx-auth-code" class="form-control" bind:value={authCode} disabled={adding} />
            </div>
        </div>
        <div class="row">
            <div class="offset-sm-2 col-sm-10">
                <button type="submit" class="btn btn-outline-secondary" disabled={adding}>
                    {#if adding}
                        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                        Un moment…
                    {:else}
                        {$_('Add')}
                    {/if}
                </button>
            </div>
        </div>
    </form>
</div>
